import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useLightMode } from '@/hooks/useLightMode'

import { CreateDropdown } from '@/components/layouts/CreateDropdown'
import { DarkGlobalEmergencyCallButton } from '@/features/emergency-call'
import { MixpanelDataIProps } from '@/features/incident-drawer'

interface DarkActionButtonsIProps {
  mixpanelData?: MixpanelDataIProps
}

/**
 * Rebrand re-skin of {@link ActionButtons}: the Emergency and Create buttons
 * rendered with the dark-package Button per the Design Library top navigation
 * bar. Must be rendered within a `DarkProvider`. See ENG-30676.
 */
export const DarkActionButtons = ({
  mixpanelData,
}: DarkActionButtonsIProps) => {
  const colorScheme = useLightMode()
  // The rebuilt menu and its dark modals belong to the application header, so
  // they follow its flag rather than whichever page flag put a dark header on
  // screen (ENG-32861).
  const isCreateMenuRebrandEnabled = useFeatureFlag(
    FeatureFlag.appHeaderRebrand
  )

  return (
    <>
      {useFeatureFlag(FeatureFlag.emergencyCall) && (
        <DarkGlobalEmergencyCallButton mixpanelData={mixpanelData} />
      )}
      <CreateDropdown
        colorScheme={colorScheme}
        isRebrandMenuEnabled={isCreateMenuRebrandEnabled}
      />
    </>
  )
}
